import { Modal } from 'rimble-ui'
import CustomButton from '../CustomButton'
import { useEffect, useState } from 'react'
import closeIcon from '../../assets/new-ui/close-icon.svg'
import { formatBalanceDisplay } from '../../utils/utils'

export default function ModalSellOption(props) {
  const RATE = 600
  const {toggleModal, setToggleModal, img, id, setPrice, price, fn} = props
  const [mode, setMode] = useState(false)
  const [usdRef, setUSDRef] = useState(null)
  const [fee, setFee] = useState(null)
  const [feeRef, setFeeRef] = useState(null)

  useEffect(() => {
    if (price && price > 0) {
      setUSDRef(price * RATE)
      setFee(price * 5 / 100)
    }
    else {
      setUSDRef(null)
      setFee(null)
    }
  },[price])

  useEffect(() => {
    if (fee) {
      setFeeRef(fee * RATE)
    }
    else setFeeRef(null)
  },[fee])

  function closeBox() {
    setMode(false)
    setUSDRef(null)
    setFee(null)
    setFeeRef(null)
    setToggleModal(false)
  }

  function confirm() {
    fn()
    closeBox()
  }

  return (
    <>
      <Modal isOpen={toggleModal}>
        <div className={mode ? 'customModal modalSellOption' : 'customModal modalSellOption modalSellOptionSmall'}>
          <img className='closeBtn' src={closeIcon} alt='close icon' onClick={() => closeBox()} />
          <div className='nftInfo'>
            <img src={img} alt='nft sell' />
            <div>ID: {id}</div>
          </div>

          {
            !mode
              ? <div className="groupBtnSell">
                  <CustomButton 
                    text={'BNB (5% fee)'}
                    fn={() => setMode(true)}
                    type={'medium'}
                    transparent={false}
                  />

                  <CustomButton 
                    text={'HLS (3% fee)'}
                    fn={() => {}}
                    type={'medium'}
                    transparent={true}
                    disabled={true}
                  />
                </div>
              : <div className='groupPrice'>
                  <div className='priceRow'>
                    <div className='priceTitle'>
                      Price
                    </div>
                    <input placeholder='000' type='number' min='0' value={price < 0 ? 0 : formatBalanceDisplay(price)} onChange={(e) => setPrice(e.target.value)} className='priceInput'/>
                    <div className='refUSDDesktop'>
                      ~
                    </div>
                    <input placeholder='$000' type='number' disabled value={usdRef&&usdRef > 0 ? usdRef : '$000'} className='priceRef'/>
                    <div className='refUSDMobile'>~ ${usdRef && usdRef > 0 ? usdRef : '$000'}</div>
                  </div>

                  <div className='priceRow'>
                    <div className='priceTitle'>
                      Fee
                    </div>
                    <input placeholder='000' type='number' value={fee && fee > 0 ? formatBalanceDisplay(fee) : '000'} disabled className='priceInput'/>
                    <div className='refUSDDesktop'>
                      ~
                    </div>
                    <input placeholder='$000' type='number' value={feeRef && feeRef > 0 ? formatBalanceDisplay(feeRef) : '$000'} disabled className='priceRef'/>
                    <div className='refUSDMobile'>~ ${feeRef ? formatBalanceDisplay(feeRef) : '$000'}</div>
                  </div>

                  <div className='groupBtnRow'>
                    <CustomButton 
                      text={'CANCEL'}
                      fn={closeBox}
                      type={'small'}
                      transparent={true}
                    />
                    
                    <CustomButton 
                      text={'CONFIRM'}
                      fn={confirm}
                      type={'small'}
                      transparent={false}
                    />
                  </div>
                </div>
            
          }
        </div>
      </Modal>
    </>
  )
}